var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.31945 16.8724L4.28601 16.4277L4.9176 14.4443L5.11212 13.8335L4.63824 13.4017L3.09956 11.9998L4.63823 10.5979L5.11212 10.1662L4.9176 9.5553L4.28602 7.5719L6.31948 7.12717L6.94576 6.9902L7.08274 6.36391L7.52746 4.33045L9.51086 4.96204L10.1217 5.15656L10.5535 4.68267L11.9554 3.14399L13.3573 4.68267L13.789 5.15656L14.3999 4.96203L16.3833 4.33045L16.828 6.36388L16.9649 6.99019L17.5912 7.12717L19.6247 7.5719L18.9931 9.5553L18.7986 10.1662L19.2725 10.5979L20.8112 11.9998L19.2725 13.4017L18.7986 13.8335L18.9931 14.4443L19.6247 16.4277L17.5912 16.8724L16.9649 17.0093L16.828 17.6357L16.3833 19.6691L14.3999 19.0375L13.789 18.843L13.3573 19.3169L11.9554 20.8556L10.5535 19.3169L10.1217 18.843L9.51086 19.0375L7.52747 19.6691L7.08274 17.6356L6.94576 17.0093L6.31945 16.8724Z",
    fill: "#FF0420",
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.193e44316a6148ac2249bc34038d480e.svg";
export { ForwardRef as ReactComponent };